module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-77-min.dd8573b0.jpg";